<div *ngIf="!!schedule" class="page">

    <div class="title">
        {{schedule.stationName}} finishing station

    </div>

    <table class="table">
        <thead>
            <tr>
                <th>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let product of (schedule.products)">
                <td class="image-td">
                    <div class="image">
                        <img *ngIf="product.version.thumbnailImageUrl"
                            [src]="product.version.thumbnailImageUrl"
                            alt="">
                    </div>
                </td>
                <td>


                    <div class="part-number">
                        {{product.version.partNumber}}
                    </div>
                    <div class="quantity">
                        {{product.completedQuantity}} / {{product.totalQuantity}}
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>